import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { _AbcSelectBoxComponent } from '@barthauer/abc/ui-components';
import { DxAccordionModule, DxCheckBoxModule, DxDataGridModule, DxSelectBoxModule, DxTemplateModule } from 'devextreme-angular';
import { DataService } from '../../services/data.service';
import { Permession } from '../user-settings/user-settings.component';

@Component({
  selector: 'app-permession-accordion',
  templateUrl: './permession-accordion.component.html',
  styleUrls: ['./permession-accordion.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DxTemplateModule,
    CommonModule,
    DxAccordionModule, _AbcSelectBoxComponent]
})
export class PermessionAccordionComponent implements OnChanges {
  @Input() modules: any;
  @Input() dataSource = [
    { value: true, displayText: 'Yes' },
    { value: false, displayText: 'No' }
  ];
  @Input() translations: any = {};
  @Output() permissionChange = new EventEmitter<any>();
  @Input() isOtherModule = true
  public PERMISSION_GRANTED = '1';
  public PERMISSION_DENIED = '0';
  public translatedModules: { [key: string]: string } = {};

  public ModuleResourceMapping = {
    ProjectSelection: 'Ubt-TreeList-Project-config',
    Subproject: 'Ubt-MeasureTask-SubProject',
    Roles: 'Ubt-TreeList-Roles',
    Companies: 'Ubt-TreeList-Companies',
    Dashboard: 'Ubt-TreeList-Dashboard',
    Report: 'Ubt-TreeList-Reports',
    'Traning-center': 'Ubt-TreeList-TrainingCenter',
    Gant: 'Ubt-TreeList-Gantt',
    Measure: 'Ubt-TreeList-Measures',
    Project: 'Ubt-TreeList-Project',
    roleRights: 'Ubt-User-Rights',
    'Measure-MileStones': 'Ubt-TreeList-Milestones-Tasks',
    Documents: 'Ubt-TreeList-Documents',
    'Stuff-Members': 'Ubt-TreeList-StaffMembers',
  };
  constructor(private dataService: DataService, private cdr: ChangeDetectorRef) { }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes.modules && changes.modules.currentValue) {
      const currentModules = changes.modules.currentValue;
      const groupedModules = currentModules.reduce((acc, module) => {
        const moduleName = module.module;


        if (!acc[moduleName]) {
          acc[moduleName] = {
            permession: [],
            ParentId: module.ParentId,
            module: moduleName
          };
        }


        acc[moduleName].permession.push({
          permessionName: module.permessionName,
          permession: module.permession,
          Id: module.Id
        });

        return acc;
      }, {});


      this.modules = Object.values(groupedModules);
      currentModules.forEach(module => {
        this.translatedModules[module.module] = this.translateModule(module.module);
      });

      this.cdr.markForCheck();
    }
  }





  public translateModule(module: string): string {

    const resourceString = this.ModuleResourceMapping[module];
    return this.dataService.res(resourceString);
  }


  public onPermissionChange(event: any, permession: Permession, module: any): void {
    if (event.event) {

      const updatedPermissions = {
        Id: permession.Id,
        ParentId: module.ParentId,
        module: module.module,
        permession: permession.permession,
        PermessionValue: permession.permession,
        permessionName: permession.permessionName
      };
      this.permissionChange.emit(updatedPermissions);
    }
  }




}

